import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate } from "react-router-dom";

import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import MailingListList from "./MailingListList";
import { PAGES_DOMAIN_URL } from "constants";

export default () => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);

  const limit = 5;

  // Fetch data
  const GET_MAILING_LIST_LIST_DATA = gql`
    query GetMailingListListData($page: Int!, $limit: Int!) {
      mailingListListData(page: $page, limit: $limit) {
        lists {
          list {
            id
            name
          }
          allLeads
          verifiedLeads
          pages
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_MAILING_LIST_LIST_DATA, {
    variables: {
      page,
      limit,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching mailing list list data", error);
    captureException(error);
  }

  const onOpenClick = (id) => {
    navigate(`/mailing-list?id=${id}`);
  };

  const openPage = (id) => {
    window.open(`${PAGES_DOMAIN_URL}/?code=${id}`, "_blank").focus();
  };

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="435px" />
        </LoadingBox>
      )}
      {data && (
        <MailingListList
          data={data}
          onOpenClick={onOpenClick}
          openPage={openPage}
        />
      )}
    </>
  );
};
